@if (visible) {
<div class="bulk-export-overlay" [ngClass]="currentTheme">
  <div class="bulk-export-modal">
    <div class="modal-header">
      <h4>Bulk PDF Export</h4>
      <div class="header-actions">
        <i class="fa fa-times hoverable" (click)="close()"></i>
      </div>
    </div>

    <div class="modal-body bulk-modal">
      <div class="group-row">
        <label>Select a Group</label>
        <select class="group-selector" [(ngModel)]="selectedGroup" (ngModelChange)="onGroupChange($event)">
          @for (g of groupList; track $index) {
<option [ngValue]="g">{{ g.name }}</option>
}
        </select>
      </div>

      <div class="accordion-container">
        <div class="accordion-item left-pane">
          <div class="step-with-search">
            <div class="step-header-box">
              <span class="step-number">Step 1</span>
              <span class="step-label">Select Entities</span>
            </div>
            <div class="search-holder">
              <span class="glyphicon glyphicon-search search-icon"></span>
              <input
                placeholder="Search..."
                type="text"
                class="search-box"
                [(ngModel)]="searchTerm"
                (ngModelChange)="filterTreeData()"
              />
            </div>
          </div>

          <div class="tree-view-content-container">
            @for (item of entityTree; track $index) {
<div
             
              class="tree-item"
              [class.hidden]="!visibleNodes(item)"
              [style.padding-left.px]="(item.lvl || 0) * 16 + 8"
            >
              <i
                class="fa tree-toggle"
                [ngClass]="getIconClass(item)"
                (click)="item.is_leaf ? null : toggleNode(item); $event.stopPropagation()"
              ></i>
              <label class="container-check" (click)="selectEntity(item, $event)">
                <input type="checkbox" [checked]="item.selected" />
                <span class="checkmark"></span>
                <span class="tree-label">
                  {{ item.name }}{{ item.is_entity ? '(' + item.leid + '/' + item.cdr_no + '/' + item.reporting_period + ')' : '' }}
                </span>
              </label>
            </div>
}
          </div>
        </div>

        <div class="accordion-item right-pane">
          <div class="step-with-search step-two">
            <div class="step-header-box">
              <span class="step-number">Step 2</span>
              <span class="step-label">Select Forms</span>
            </div>
            <div class="search-holder">
              <span class="glyphicon glyphicon-search search-icon"></span>
              <input
                placeholder="Search Forms..."
                type="text"
                class="search-box"
                [(ngModel)]="formSearchTerm"
                (ngModelChange)="searchForm()"
              />
            </div>
            @if (!formLoading && noFormsMsg.length === 0) {
<label class="container-check download-all">
              <span>Download All Forms</span>
              <input type="checkbox" [(ngModel)]="downloadAllForms" (change)="selectAllForm()" />
              <span class="checkmark"></span>
            </label>
}
          </div>

          <div class="forms-wrapper">
            @if (formLoading) {
<div class="form-loader-container">
              <i class="fa fa-spinner fa-spin"></i>
            </div>
}
            @if (!formLoading && noFormsMsg.length > 0) {
<div class="form-loader-container">
              <h5>{{ noFormsMsg }}</h5>
            </div>
}

            @if (!formLoading && noFormsMsg.length === 0) {
<div class="forms-grid">
              <div class="forms-col" [class.single-col]="!foreignFormsDisplay">
                @for (item of forms; track $index) {
<div
                 
                  class="tree-item"
                  [class.hidden]="item.type !== 'D' || !visibleNodes(item)"
                  [style.padding-left.px]="(item.lvl || 0) * 16 + 8"
                >
                  <i
                    class="fa tree-toggle"
                    [ngClass]="item.is_leaf ? 'fa-file-pdf-o no-icon-adjust' : (item.childrenHidden ? 'fa-chevron-circle-right' : 'fa-chevron-circle-down')"
                    (click)="item.is_leaf ? null : toggleFormNode(item); $event.stopPropagation()"
                  ></i>
                  <label class="container-check" (click)="selectForm(item, $event)">
                    <input type="checkbox" [checked]="item.selected" />
                    <span class="checkmark"></span>
                    <span class="tree-label">
                      {{ item.label }}{{ item.lvl > 0 && !item.is_leaf ? ' (' + getRecordsCount('forms', item.form) + ')' : '' }}
                    </span>
                  </label>
                </div>
}
              </div>

              @if (foreignFormsDisplay) {
<div class="forms-col">
                @for (item of forms; track $index) {
<div
                 
                  class="tree-item"
                  [class.hidden]="item.type !== 'F' || !visibleNodes(item)"
                  [style.padding-left.px]="(item.lvl || 0) * 16 + 8"
                >
                  <i
                    class="fa tree-toggle"
                    [ngClass]="item.is_leaf ? 'fa-file-pdf-o no-icon-adjust' : (item.childrenHidden ? 'fa-chevron-circle-right' : 'fa-chevron-circle-down')"
                    (click)="item.is_leaf ? null : toggleFormNode(item); $event.stopPropagation()"
                  ></i>
                  <label class="container-check" (click)="selectForm(item, $event)">
                    <input type="checkbox" [checked]="item.selected" />
                    <span class="checkmark"></span>
                    <span class="tree-label">
                      {{ item.label }}{{ item.lvl > 0 && !item.is_leaf ? ' (' + getRecordsCount('forms', item.form) + ')' : '' }}
                    </span>
                  </label>
                </div>
}
              </div>
}
            </div>
}
          </div>

          <!-- Step 3: same column as Step 2; below forms scroll area, not inside it. -->
          <div class="file-type-row">
            <div class="step-header-box">
              <span class="step-number">Step 3</span>
              <span class="step-label">Select File Type</span>
            </div>
            <div class="selection-wrapper">
              <label class="type-label">PDF:</label>
              @for (format of PDFformats; track $index) {
<label class="container-check radio-opt" (click)="selectFormat(format, $event)">
                <input type="checkbox" [checked]="format.selected" tabindex="-1" />
                <span class="checkmark radio"></span>
                <span class="option-text">{{ format.name }}</span>
              </label>
}
            </div>
            <div class="selection-wrapper">
              <label class="type-label">XML:</label>
              @for (format of XMLformats; track $index) {
<label class="container-check radio-opt" (click)="selectFormat(format, $event)">
                <input type="checkbox" [checked]="format.selected" tabindex="-1" />
                <span class="checkmark radio"></span>
                <span class="option-text">{{ format.name }}</span>
              </label>
}
            </div>
            <div class="selection-wrapper">
              <label class="type-label">ZIP:</label>
              @for (format of ZIPformats; track $index) {
<label class="container-check radio-opt" (click)="selectFormat(format, $event)">
                <input type="checkbox" [checked]="format.selected" tabindex="-1" />
                <span class="checkmark radio"></span>
                <span class="option-text">{{ format.name }}</span>
              </label>
}
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="modal-footer">
      @if (exportLoading) {
<i class="fa fa-spinner fa-spin loading-icon"></i>
}
      <button
        class="btn btn-info"
        [disabled]="exportDisable || exportLoading"
        (click)="onPdfExportClick()"
      >
        PDF Export
      </button>
      <button class="btn btn-warning" (click)="close()">Cancel</button>
    </div>
  </div>
</div>
}

<!--
  Legacy parity (bulk-export-modal.html L721): the first PDF Export button uses
  `ng-really-message="Are you exporting the files for client review"` to confirm
  before `checkForDiagnostics()` (Yes) or fall back to `bulkExport()` (No).

  NOTE: gtw-confirmation-modal does not internally honor [visible]; we MUST
  gate it with *ngIf, otherwise it renders unconditionally on this template
  and appears whenever the host bulk-export component is in the DOM.
-->
@if (showClientReviewExportConfirm) {
<gtw-confirmation-modal
 
  [config]="clientReviewExportConfirmConfig"
  [visible]="showClientReviewExportConfirm"
  (confirmed)="onClientReviewExportConfirmed()"
  (cancelled)="onClientReviewExportCancelled()"
  (closed)="onClientReviewExportCancelled()">
</gtw-confirmation-modal>
}
